var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "#000000",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-lock")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/lock",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C15.2377045,0 17.8775403,2.56625155 17.9958605,5.77510787 L18,6 L18,10 L21,10 L21,24 L3,24 L3,10 L6,10 L6,6 C6,2.687 8.687,0 12,0 Z M12,14 C10.896,14 10,14.896 10,16 C10,16.6821538 10.3450888,17.2773964 10.8661629,17.6378607 L11,17.723 L11,20 L13,20 L13,17.723 C13.596,17.376 14,16.738 14,16 C14,14.896 13.104,14 12,14 Z M12,2 C9.86084848,2 8.1091056,3.68692011 8.00490369,5.80062799 L8,6 L8,10 L16,10 L16,6 C16,3.794 14.205,2 12,2 Z",
  id: "Shape"
})))));
export default SvgLock;